import { render } from "./SoldDisposedItems.vue?vue&type=template&id=6acb8388"
import script from "./SoldDisposedItems.vue?vue&type=script&lang=js"
export * from "./SoldDisposedItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__